import React, { PropTypes } from 'react';
import DisableableLink from '../common/DisableableLink';

const NoClonesView = React.createClass({
    propTypes: {
        image: PropTypes.object.isRequired,
        canCreate: PropTypes.bool.isRequired
    },
    render: function () {
        const { image, canCreate } = this.props;

        return <div className="pure-u-1-1">
            <div className="empty-image">
                <p>This image doesn’t have any clones</p>
                <DisableableLink className="button--flat" to={'/clones/create/source?imageId=' + image.id} disabled={!canCreate}>Clone</DisableableLink>
            </div>
        </div>;
    }
});

export default NoClonesView;



// WEBPACK FOOTER //
// ./src/components/dashboard/NoClones.jsx